function get_faq_btn(handle){
  
  let btn = '<modal-opener class="product-popup-modal__opener quick-add-hidden faq_btn e4m_' + handle + '" data-modal="#PopupModal-popup_my-modal">';
  btn +=    '<button class="product-popup-modal__button link" type="button" aria-haspopup="dialog" onclick="load_faq(\'' + handle + '\')">';
  btn +=    '<span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-accordion icon-question-mark" viewBox="0 0 20 20">';
  btn +=    '<path d="M9.563 11.959a.367.367 0 0 1-.367-.367v-.127c-.003-.49.084-.91.316-1.303.227-.384.575-.715 1.04-1.063.415-.311.666-.566.817-.81a1.43 1.43 0 0 0 .208-.795v-.013c0-.894-.657-1.531-1.568-1.531-.862 0-1.527.606-1.612 1.609a.37.37 0 0 1-.097.219l-.006.006a.37.37 0 0 1-.264.117l-.471.007a.367.367 0 0 1-.362-.453c.112-1.519 1.219-2.712 2.825-2.712 1.603 0 2.791 1.176 2.791 2.718v.013c0 .512-.114.965-.366 1.387-.248.416-.619.783-1.101 1.145l-.003.002c-.414.305-.637.526-.764.738-.12.2-.172.422-.172.771v.075a.367.367 0 0 1-.367.367zm1.142 2.423c0 .473-.335.88-.838.88-.497 0-.845-.4-.845-.88 0-.477.351-.874.845-.874.5 0 .838.403.838.874"/><path d="M18.5 10a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0M10 17.497a7.497 7.497 0 1 0 0-14.994 7.497 7.497 0 0 0 0 14.994"/>';
  btn +=    '</svg></span>';
  btn +=    '</button>';
  btn +=    '</modal-opener>';
 
  return btn;
}

function load_faq(handle){

  if(faqs[handle] !== undefined){
 
    // put content into modal
    // get modal   
    const m = document.getElementById("PopupModal-popup_my-modal");
    // get header
    const h2 = m.querySelector('.product-popup-modal__content-info h2 span');
    // set new header
    h2.innerHTML = faqs[handle]['f'];
    // get body
    const b = m.querySelector('.product-popup-modal__content-info .my_modal_body');
    b.innerHTML = faqs[handle]['a'];
  
    // add image if available
    b.innerHTML += (faqs[handle]['b'] !== undefined) ? '<p class="img_wrapper"><img src="' + faqs[handle]['b'] + '" width="" height=""></p>': '';
    b.innerHTML += (faqs[handle]['a2'] !== undefined) ? faqs[handle]['a2']: '';
    b.innerHTML += (faqs[handle]['b2'] !== undefined) ? '<p class="img_wrapper"><img src="' + faqs[handle]['b2'] + '" width="" height=""></p>': '';
    b.innerHTML += (faqs[handle]['a3'] !== undefined) ? faqs[handle]['a3']: '';
    b.innerHTML += (faqs[handle]['b3'] !== undefined) ? '<p class="img_wrapper"><img src="' + faqs[handle]['b3'] + '" width="" height=""></p>': '';
    
    $('.product-popup-modal__content').scrollTop(0); 
  }
}


function set_faq_btns(type){

  /* DEL?
  if(type == 'variants'){
    // set variants btns
    let variant_dr = $('variant-selects fieldset:first-child');
    let variant_oa = $('variant-selects fieldset:nth-child(2)');
    if($(variant_dr).length){ $(variant_dr).find('legend').append(get_faq_btn('drehrichtung')) }
    if($(variant_oa).length){ $(variant_oa).find('legend').append(get_faq_btn('oberflache-aussen')) }
  }
  */

  if(type == 'options'){

    $('.cl-po--wrapper').find('.cl-po--option').each(function(){

      var label = $(this).children('.cl-po--label').contents().filter(function() {
                    return this.nodeType === 3; // Node.TEXT_NODE
                  }).text().trim();

      //var label = $(this).attr('data-option');
      
      const faq_key = Object.keys(faqs).find(key => faqs[key].f === label);
      if (faq_key !== undefined) {
        let ex_faq_btn = $('modal-opener.e4m_' + faq_key);            
        if(!ex_faq_btn.length) $(this).first().append(get_faq_btn(faq_key));
      }
    });
  }
}